var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 63,
    viewBox: "0 0 67 63",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6339 0.83375C32.9385 -0.0764508 34.2259 -0.0764504 34.5305 0.83375L41.7418 22.3829C41.8773 22.7875 42.2545 23.0616 42.6811 23.0655L65.3899 23.2701C66.3493 23.2788 66.7471 24.5024 65.9762 25.0735L47.7234 38.5982C47.3808 38.852 47.2368 39.2952 47.3648 39.7019L54.1879 61.3796C54.4761 62.2949 53.4345 63.0512 52.6533 62.4939L34.1629 49.3025C33.8154 49.0546 33.3489 49.0546 33.0014 49.3025L14.511 62.4939C13.7298 63.0512 12.6883 62.2949 12.9764 61.3796L19.7995 39.7019C19.9275 39.2952 19.7836 38.852 19.441 38.5982L1.18809 25.0735C0.417242 24.5024 0.815066 23.2788 1.77442 23.2701L24.4832 23.0655C24.9099 23.0616 25.2871 22.7875 25.4225 22.3829L32.6339 0.83375Z",
    fill: "#FFE682"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/filled_star.2eb37a42df744e52590ab05ee310de20.svg";
export { ForwardRef as ReactComponent };